import React from 'react';
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import { VisitBadge } from './reportUi';

// Taluka's report grouped PHC → गटप्रवर्तक → ASHA workers. The data comes from
// /admin/reports/asha-visits/by-gatpravartak, already scoped to what the
// signed-in user may see.
export default function GatpravartakReport({ phcs }) {
  if (!phcs || phcs.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ p: 4, textAlign: 'center' }}>
        कोणताही डेटा उपलब्ध नाही
      </Typography>
    );
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      {phcs.map((phc) => (
        <Paper key={phc.phc} variant="outlined" sx={{ borderRadius: 3, borderColor: 'grey.200', overflow: 'hidden' }}>
          <Box sx={{ px: 2.5, py: 1.75, bgcolor: 'grey.50', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
            <Typography sx={{ fontWeight: 800 }}>{phc.phc}</Typography>
            <Typography sx={{ fontSize: '0.935rem', color: 'grey.700' }}>
              {phc.totalAshaWorkers} आशा · {phc.totalMothers} माता · {phc.totalVisits} भेटी
            </Typography>
          </Box>
          {phc.gatpravartaks.map((g) => (
            <Box key={g.supervisorId || 'unassigned'} sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'grey.200' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                <Typography sx={{ fontWeight: 700, color: 'primary.main' }}>गटप्रवर्तक: {g.supervisorName}</Typography>
                <Typography sx={{ fontSize: '0.902rem', color: 'grey.600' }}>
                  {g.totalAshaWorkers} आशा · {g.totalMothers} माता · {g.totalVisits} भेटी
                </Typography>
              </Box>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ '& th': { bgcolor: 'grey.100', fontWeight: 700, color: 'grey.700', fontSize: '0.858rem' } }}>
                      <TableCell>आशा कार्यकर्ता</TableCell>
                      <TableCell>उप-केंद्र</TableCell>
                      <TableCell align="center">माता</TableCell>
                      <TableCell align="center">भेटी</TableCell>
                      <TableCell>शेवटची भेट</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {g.workers.map((w) => (
                      <TableRow key={w.ashaWorkerId} hover>
                        <TableCell sx={{ fontWeight: 600 }}>{w.ashaWorkerName}</TableCell>
                        <TableCell>{w.subCentre}</TableCell>
                        <TableCell align="center">{w.totalMothers}</TableCell>
                        <TableCell align="center"><VisitBadge value={w.totalVisits} /></TableCell>
                        <TableCell>{w.lastVisitDate || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
        </Paper>
      ))}
    </Box>
  );
}
